import { useState, useRef, useEffect } from 'react';
import './HeaderGlobalFilter.css';

const HeaderGlobalFilter = () => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const filterButtonRef = useRef(null);
  const tooltipRef = useRef(null);
  
  // Handle escape key to close tooltip
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isTooltipVisible) {
        setIsTooltipVisible(false);
      }
    };
    
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isTooltipVisible]);
  
  // Close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        tooltipRef.current && 
        !tooltipRef.current.contains(event.target) && 
        !filterButtonRef.current.contains(event.target)
      ) {
        setIsTooltipVisible(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
};

export default HeaderGlobalFilter;
